import * as yup from 'yup';

export const SubmitSalesProjectResponseSchema = yup.object({
  id: yup.number().defined(),
});

export type SubmitSalesProjectResponse = yup.InferType<
  typeof SubmitSalesProjectResponseSchema
>;
